export default __webpack_public_path__ + "static/assets/c9511f360d83de3bce6b551b1a4fe8b4.gif";